<template>

  <div class="matrikel" v-if="loaded">
    
    <div v-if="loaded">
      <img v-bind:src=front />
      <img v-bind:src=ambetsman />
      <Brother 
        v-for="brother in brothers"
        v-bind:key="brother.id"
        v-bind:brother="brother"
      />
      <img v-bind:src=memoriam />
    </div>
    <font-awesome-icon icon="spinner" spin v-if="!loaded" />
  </div>
</template>
<script>
import rest from "../rest";
import Brother from '../components/Brother'
import front from '@/assets/img/MatrikelFront.png'
import ambetsman from '@/assets/img/Ambetsman.png'
import memoriam from '@/assets/img/Memoriam.png'

export default {
  name: "brothers",
  components: {Brother},
  data() {
    return {
      brothers: null,
      loaded: false
    };
  },
  computed:{
    modelsSet(){
      return this.brothers && this.users
    },
    front(){
      return front;
    },
    ambetsman(){
      return ambetsman;
    },
    memoriam(){
      return memoriam;
    }
  },
  methods: {
    init() {
      rest.brothers().then(res => {
        this.brothers = res.data.data;
        rest.users().then(result =>{
          const users = result.data.data;
          this.brothers.forEach(brother =>{
            brother.userData = users.find(user => user.id === brother.user);
            brother.sponsorData = users.find(user => user.id === brother.sponsor);
          })
          this.loaded = true;
        })
      });
      
    },
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped>
.matrikel{
  display: flex;
}
.matrikel img {
  height: 590px;
  padding: 46px 10px;
  page-break-after: always;
}
</style>
